import type { QueryClient } from '@tanstack/react-query'

/**
 * GET/POST /projects/{projectId}/development-tasks/{taskId}/preview-request
 * 的回执缓存键。GET latest 按 task id 读最近一条。
 */
export function developmentTaskPreviewReceiptKey(taskId: string) {
  return ['development-tasks', taskId, 'preview-receipt'] as const
}

export function rememberPreviewReceipt(queryClient: QueryClient, taskId: string, receipt: unknown) {
  queryClient.setQueryData(developmentTaskPreviewReceiptKey(taskId), receipt)
}
